import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '0px',
        marginBottom: '15px',
        border: '1px solid #e35b66',
        borderRadius: '5px',
        height: '100%',
        backgroundColor: '#fff0f1',
        paddingLeft: '10px',
        width: '87%',
        maxWidth: '600px',
        marginLeft: theme.spacing(1),
    },
    typography: {
        color: '#cc3340',
        position: 'relative',
        top: '-5px',
        display: 'inline',
        paddingLeft: '10px'
    },
    errorIcon: {
        display: 'inline',
        color: '#cc3340'
    }
}));

const Error = ({errorMessage}) => {
    const classes = useStyles();
    return(
        <div className={classes.root}>
            <ErrorOutlineIcon
                className={classes.errorIcon}
            />
            <p className={classes.typography}>
                {errorMessage}
            </p>
        </div>
    )
}

export default Error